import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import pick from 'lodash.pick';
import { theme } from "../../theme";
import { getBackgroundColor, getTextColor } from "../../theme/color-tokens";
var styleOptions = ['display', 'position', 'top', 'right', 'bottom', 'left', 'flexDirection', 'flexShrink', 'flexGrow', 'flexWrap', 'alignItems', 'flexBasis', 'justifyContent', 'textAlign', 'overflow', 'transform'];
export var boxStyles = function boxStyles(props) {
  var styles = pick(props, styleOptions);
  return _objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
    color: getTextColor(props.color),
    backgroundColor: getBackgroundColor(props.backgroundColor),
    borderRadius: theme.radii[props.borderRadius]
  }, getSizes(props)), getPadding(props));
};

var getPadding = function getPadding(_ref) {
  var padding = _ref.padding,
      paddingTop = _ref.paddingTop,
      paddingY = _ref.paddingY,
      paddingBottom = _ref.paddingBottom,
      paddingX = _ref.paddingX,
      paddingLeft = _ref.paddingLeft,
      paddingRight = _ref.paddingRight;
  var resolvedPaddingTop = paddingTop || paddingY || padding;
  var resolvedPaddingBottom = paddingBottom || paddingY || padding;
  var resolvedPaddingLeft = paddingLeft || paddingX || padding;
  var resolvedPaddingRight = paddingRight || paddingX || padding;
  return {
    paddingLeft: theme.spaces[resolvedPaddingLeft],
    paddingTop: theme.spaces[resolvedPaddingTop],
    paddingBottom: theme.spaces[resolvedPaddingBottom],
    paddingRight: theme.spaces[resolvedPaddingRight]
  };
};

var getSizes = function getSizes(_ref2) {
  var _theme$spaces$width, _theme$spaces$height, _theme$spaces$maxWidt, _theme$spaces$maxHeig, _theme$spaces$minWidt, _theme$spaces$minHeig;

  var width = _ref2.width,
      height = _ref2.height,
      maxWidth = _ref2.maxWidth,
      maxHeight = _ref2.maxHeight,
      minWidth = _ref2.minWidth,
      minHeight = _ref2.minHeight;
  return {
    width: (_theme$spaces$width = theme.spaces[width]) !== null && _theme$spaces$width !== void 0 ? _theme$spaces$width : width,
    height: (_theme$spaces$height = theme.spaces[height]) !== null && _theme$spaces$height !== void 0 ? _theme$spaces$height : height,
    maxWidth: (_theme$spaces$maxWidt = theme.spaces[maxWidth]) !== null && _theme$spaces$maxWidt !== void 0 ? _theme$spaces$maxWidt : maxWidth,
    maxHeight: (_theme$spaces$maxHeig = theme.spaces[maxHeight]) !== null && _theme$spaces$maxHeig !== void 0 ? _theme$spaces$maxHeig : maxHeight,
    minWidth: (_theme$spaces$minWidt = theme.spaces[minWidth]) !== null && _theme$spaces$minWidt !== void 0 ? _theme$spaces$minWidt : minWidth,
    minHeight: (_theme$spaces$minHeig = theme.spaces[minHeight]) !== null && _theme$spaces$minHeig !== void 0 ? _theme$spaces$minHeig : minHeight
  };
};

var filterProps = [].concat(styleOptions, ['width', 'height', 'maxWidth', 'maxHeight', 'minWidth', 'minHeight', 'paddingY', 'paddingX', 'paddingBottom', 'paddingRight', 'paddingLeft', 'paddingTop', 'padding', 'borderRadius', 'color', 'backgroundColor', 'background']);
export var shouldForwardProp = function shouldForwardProp(prop) {
  return !filterProps.includes(prop);
};